module.exports = __webpack_public_path__ + "img/monthly_payment.a31770fc.png";